import { Constants } from "@constants";

import axios from "axios";
import { getAuthorizationToken, queryStringToObject } from "./helper";

const apiService = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL: baseURL
      ? baseURL
      : `${Constants.API.API_PATH}${Constants.API.BASE_API_URL}`,
    withCredentials: true,
  });

  axiosInstance.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );

  return axiosInstance;
};

const requestHandler = (request) => {
  const token = getAuthorizationToken(Constants.GENIE_ACCESS_CODE);
  request.headers.Authorization = token ? `Bearer ${token}` : "";
  request.headers["Cache-Control"] = "no-cache";
  return request;
};

const responseHandler = (response) => {
  let bearerToken = response?.headers?.[Constants.GENIE_ACCESS_CODE];
  if (bearerToken) {
    if (bearerToken?.toLowerCase()?.startsWith('bearer')) {
      bearerToken = bearerToken.replace(/^Bearer\s+/i, '');
    }
    localStorage.setItem(Constants.GENIE_ACCESS_CODE, bearerToken);
  }
  return response;
};

const errorHandler = (error) => {
  requestInterceptorsHandler(error);
  return Promise.reject(error);
};

const requestInterceptorsHandler = (res) => {
  const origin = window.location.origin;
  const { response = {} } = res;
  // Instead of JUST 401, we want to redirect the user to sign-in page if it's a non-200 HTTP
  // But, it should only be redirected if the user has not come from sign-in page 
  // (indicated by "login=true" set in the params by the below code)
  const { login = false } = queryStringToObject(window?.location?.search);
  if (!login) {
    let HOST = response?.data?.data?.host || `${window.location.origin}${Constants.ROUTES.GENIE_AUTH_URL_FE_ROUTE}?TARGET=`;
    if (origin.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1) {
      HOST = `${Constants.ROUTES.GENIE_AUTH_URL}?TARGET=`;
    }

    HOST = HOST + encodeURIComponent(`${window.location.href}${window.location.search ? '&' : '?'}login=true`);
    if (window.location.pathname.includes("cybersecurity-insights")) {
      HOST = `${HOST}${Constants.ROUTES.GENIE_AUTH_PARAMS}`;
    }
    window.location.replace(HOST);
  }
};
export { requestInterceptorsHandler };
export default apiService;
